(function ($) {
  'use strict';

  window.ys.TD2024 = new TD2024();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('page-template-skoda-titan-desert-2024')) {
    window.ys.TD2024Contest = new TD2024.Contest();
  }
}).bind(window)(jQuery);
